import type { StockAvailability } from './validate-stock-status';
import { validateStockStatus } from './validate-stock-status';

type GetDeliveryMethodStockAvailabilityParams = {
    minimumCaseQty: number;
    isCustomPharmacyOOS: boolean;
    availableStock: Maybe<number>;
    isDoordashAvailable?: boolean;
    purchaseOption: 'one-time' | 'autoship';
    availablePurchaseOptions: Maybe<{ oneTime: boolean; autoship: boolean }>;
};

export const getDeliveryMethodStockAvailability = ({
    availableStock,
    minimumCaseQty,
    purchaseOption,
    isCustomPharmacyOOS,
    isDoordashAvailable,
    availablePurchaseOptions,
}: GetDeliveryMethodStockAvailabilityParams): StockAvailability | null => {
    const key = purchaseOption === 'autoship' ? 'autoship' : 'oneTime';
    const isAvailable = availablePurchaseOptions?.[key];

    if (!isAvailable || availableStock == null) return null;

    return validateStockStatus({
        availableStock,
        minimumCaseQty,
        isCustomPharmacyOOS,
        isDoordashAvailable,
    });
};
